import { useEffect, useMemo } from 'react';
import { getDistance, getCurrentIndex } from './utils';

const TIMEOUT_MS = 1000;

const useScrollEnd = ({ refContainer, enabled }, callback) => {
  const container = refContainer?.current;
  const shouldAttachScroll = enabled && container;
  const threshold = useMemo(
    () => (shouldAttachScroll ? container?.firstChild?.clientWidth : null),
    [container, shouldAttachScroll],
  );

  useEffect(() => {
    let timeout = null;

    const handleOnScroll = event => {
      const distance = getDistance(event);
      const index = threshold ? getCurrentIndex(threshold, distance) : null;
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        if (index) callback(index);
      }, TIMEOUT_MS);
    };

    if (shouldAttachScroll) {
      container.addEventListener('scroll', handleOnScroll);
    }

    return () => {
      if (shouldAttachScroll) {
        container.removeEventListener('scroll', handleOnScroll);
      }
    };
  }, [callback, container, shouldAttachScroll, threshold]);
};

export default useScrollEnd;
